import React, { useState } from 'react';
import { PortableText } from '@portabletext/react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { buildMarksTree } from '@portabletext/toolkit';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { alpha } from '@tmap/mmm-style-guide/src/alpha';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { ArrowForward } from '@tmap/mmm-style-guide/src/Icon';
import { Card } from '@tmap/mmm-style-guide/src/Card';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const ByTheNumbersCard = styled(Card)(({ theme }) => ({
  borderRadius: '16px',
  background: alpha(theme.palette.convert.veryLight, 0.25),
  padding: theme.spacing(2, 4),
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(2, 3),
  },
}));

const statisticComponents = {
  types: {
    block(props) {
      // TODO: Remove me and buildMarksTree import if they add children back to props again.
      if (!props.children) {
        // eslint-disable-next-line no-param-reassign
        props = {
          ...props,
          children: buildMarksTree(props.value).map((child, i) => props.renderNode({
            node: child,
            isInline: true,
            index: i,
            renderNode: props.renderNode,
          })),
        };
      }
      return props.children || null;
    },
  },
  marks: {
    strong(props) {
      return <Typography component='span' fontSize='inherit' color='inherit' fontWeight={700}>{props.children}</Typography>;
    },
  },
};

function ByTheNumbersWidget(props) {
  const { stats } = props;
  const [index, setIndex] = useState(0);
  const totalItems = stats.length;

  const incrementItem = () => {
    setIndex((i) => (i + 1) % totalItems);
  };

  const item = stats[index];

  return (
    <ByTheNumbersCard elevation={0}>
      <Grid container spacing={{ xs: 2, md: 4 }} alignItems='center' padding={0.5}>
        <Grid item xs={12} md='auto'>
          <Typography component='div' variant='overline' fontSize='12px' color='convert.main'>By the Numbers</Typography>
        </Grid>
        <Grid item xs={12} md>
          <Typography component='div' fontSize='20px' fontWeight={500} color='convert.dark' sx={{ minHeight: { xs: '5em', sm: '2em', md: 'unset' } }}>
            <PortableText
              value={item.statisticBlockContent}
              components={statisticComponents}
            />
          </Typography>
        </Grid>
        <Grid item xs={12} md='auto' sx={{ textAlign: 'right' }}>
          <Button color='convert' size='small' onClick={incrementItem} endIcon={<ArrowForward />}>
            {index + 1}/{totalItems}
          </Button>
        </Grid>
      </Grid>
    </ByTheNumbersCard>
  );
}

export default ByTheNumbersWidget;
